export default __webpack_public_path__ + "static/media/right_arrow_red.846c92eb.svg";